import _ from "underscore";
import $ from "jquery";
import render from "../../utilities/render";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements, setUniqNamesAndIds} from "../../utilities/selectorHelpers";
import {instantiateSwitchery, setSwitchery} from '../../utilities/instantiateSwitchery';
import {createPreventDefault, isPresent, isTruthy, isBlank} from '../../utilities/general';
import { isNullOrUndefined } from 'util';

const elementsMap = {
  companyName: '.company-name',
  taxId: '.tax-id',
  url: '.primary-url',
  prefix: '.ret-prefix',
  firstName: '.ret-first-name',
  lastName: '.ret-last-name',
  email: '.ret-email',
  duplicateMessage: '#duplicate-message',
  affMerchantText:'.aff-merchant-text',
  affMerchantName: '#aff-merchant-name',
  addMerchantBtn: '.add-merchant-btn',
  fedexCanCall: '.fedex-can-call',
  addMobileBtn: '.add-mobile-number-btn',
  removeMobileBtn: '.remove-mobile-btn',
  addressSection: '.address-section',
  contactSection: '.contact-section',
  phoneSection: '.phone-section',
  addAffMerchant: '.add-aff-merchant',
  masterAccountSection :'.master-account-section',
  masterAccountToggleCheckbox : '.master-account-toggle-checkbox',
  managedByMasterAccountSection : '.managed-by-master-account-section',
  managedByMasteraccountToggleCheckbox : '.managed-by-masteraccount-toggle-checkbox',
  masteraccountDropdown : '.masteraccount-dropdown',
  supplyChainFacilitySection : '.supplychain-facility-section',
  //addressValidSwitch:'.address-valid-switch',
  insightFeedSwitch:'.insight-feed-switch',
  merchantTiers:'.merchant-tier',
  fontanaFedExId :".Fontana-fedex-id",
  greenwoodFedexId:".Greenwood-fedex-id",
  fuelSurchrgSwitch:'.fuel-Surchrg-switch',
  directBillSwitch:'.direct-bill-switch'
};

const addressElementsMap = {
  country: '.ret-country',
  address1: '.ret-address1',
  address2: '.ret-address2',
  city: '.ret-city',
  state: '.ret-state',
  zipCode: '.ret-zip-code',
  postalCodeLabel:'#postalcode-label',
  stateLabel:'#state-label',
  county: '.ret-county',
  countyMandatoryLabel: '.county-mandatory-label',
  stateSelectContainer: '.state-wrapper',
  stateTextContainer: '.state-text-wrapper',
  stateTextInput: '.ret-state-text',
  commercialAddressFlag: '.commercial-addr-flag'
};

 const phoneElementsMap = {
  officeCountryCode: '.ret-office-country-code',
  officePhone: '.ret-office-phone',
  officeAreaCode: '.ret-office-area-code',
  officeExt: '.ret-office-ext',
  mobileCountryCode: '.ret-mobile-country-code',
  mobilePhone: '.ret-mobile-phone',
  mobileAreaCode: '.ret-mobile-area-code',
  mobilePhoneSection: '.ret-mobile-number-section'
 };

export default function PrimaryTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const els = {};
  const retailerWizard = $('#retailer-wizard');
  const validationReqdCountries = JSON.parse(retailerWizard.attr("data-validation-reqd-countries"));    
  const primaryTab = wizardElement.find('.primary-information-tab');
  const defaultContry = wizardElement.data('default-country');
  const usaStates = wizardElement.data('usa-states');
  const caProvinces = wizardElement.data('ca-provinces');
  const countriesPhoneCodeList = wizardElement.data('country-phone-code-list');
  const countries = wizardElement.data('countries');
  const prefixes = wizardElement.data('prefixes');
  const retailerJsonString = wizardElement.data('retailer-obj');
  const rtlType = wizardElement.data('rtl-type');
  const parentRetailersList = wizardElement.data('parent-retailers').data;
  const merchantTier = wizardElement.data('merchant-tiers');
  let countryId;
  self.init = function(){
    renderPrimaryTab();
  };

  function renderPrimaryTab(){
    setElements();
    // jquery validator needs that all "name" attribute are unique and we are usinng same phone and address template on each tab.
    setUniqNamesAndIds(els);
    // SInce we are adding dynamic uuid to id and name for each element and since the "for" attribute
    // needs same string as id of element, fedexCanCall checkbox was not getting clicked.
    $("label[for=fedex-can-call]").attr("for", els.fedexCanCall.attr("id"));
    bindElements();
    loadDropDowns();
    setStates(defaultContry);
    renderViewWithData();
    els.masterAccountToggleCheckbox.on('change', masterAccountToggleChange);

    function masterAccountToggleChange() {
     let isChecked = $(this).is(':checked');
     if (isChecked) {
      els.managedByMasterAccountSection.addClass('q-display-none');      
     } else {
      els.managedByMasterAccountSection.removeClass('q-display-none');
     }

     els.masterAccountToggleCheckbox.checked=isChecked;
      els.managedByMasteraccountToggleCheckbox.checked=!isChecked;
   }

   els.managedByMasteraccountToggleCheckbox.on('change', managedByMasterAccountToggleChange);
   
   function managedByMasterAccountToggleChange() {
    let isChecked = $(this).is(':checked');
   if (isChecked) {
     els.masterAccountSection.addClass('q-display-none');
   } else {
      els.masterAccountSection.removeClass('q-display-none');
   }

   els.managedByMasteraccountToggleCheckbox.checked=isChecked;
   els.masterAccountToggleCheckbox.checked=!isChecked;
 }
    els.addMerchantBtn.on('click', function(e){
      e.preventDefault();
      let affMerchantNameValue = els.affMerchantName.val().trim();
      let addedAffiliatedMerchantHtml = ` <div class="col-xs-12 aff-merchant-text q-marg-top-md">
              <input class="q-input q-stretch affMerchantNameValue" 
              type="text" id="${affMerchantNameValue}" value="${affMerchantNameValue}"/>
              </div>`;
      if(affMerchantNameValue && affMerchantNameValue.trim() != ''){
        let valuesExists = false;
        $.each($('.affMerchantNameValue'), function(ind, element){
          let existingVal = $(element).val();
          if(affMerchantNameValue.toString().toUpperCase() === existingVal.toString().toUpperCase()){
            valuesExists = true;
            els.duplicateMessage.show();
          }
        });
        if(!valuesExists){
          els.duplicateMessage.hide();
          els.addAffMerchant.append(addedAffiliatedMerchantHtml);
        }
      }
      els.affMerchantName.val('');
    });
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, primaryTab);
    setElementsFromScope(els, addressElementsMap, primaryTab);
    setElementsFromScope(els, phoneElementsMap, primaryTab);
  }

  function bindElements() {
    els.country.on("change", countryChange);
    els.officeCountryCode.on("change",officeCountryCodeChange);
    els.mobileCountryCode.on("change",mobileCountryCodeChange);
    $(document).on("click", '.primary-information-tab .add-mobile-number-btn', handleAddMobileBtn);
    $(document).on("click", '.primary-information-tab .remove-mobile-btn', handleRemoveMobileBtn);
    els.directBillSwitch.on("change",validateDirectBillField);
    els.fuelSurchrgSwitch.on("change",validateFuelSurchargeField);
  }

  function loadDropDowns() {
    $(countries).each(function(){
      var option = $('<option />');
      option.attr('value', this.conCode).text(this.conName);
      els.country.append(option);
    });

    $(countriesPhoneCodeList).each(function(){
      var option = $('<option />');
      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
      els.officeCountryCode.append(option);
    });

    $(countriesPhoneCodeList).each(function(){
      var option = $('<option />');
      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
      els.mobileCountryCode.append(option);
    });

    $(prefixes).each(function(){
      var option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
      els.prefix.append(option);
    });
    
    let retailerObj=getRetailer();

    $(parentRetailersList).each(function(){
      var option = $('<option />');
      option.attr('value', this.rtlId).text(this.rtlName);
      if(_.isObject(retailerObj)){
        if(this.rtlId==retailerObj.rtlMasterAccountId){
          option.attr('selected','true');        
        }
      }
      els.masteraccountDropdown.append(option);      
    });
    
    // E-111737  commented for Enable ability to update individual merchant to parent/child START
    // if(_.isObject(retailerObj)) {
    //  els.masteraccountDropdown.attr('disabled', 'disabled');
    // }
    // E-111737 Enable ability to update individual merchant to parent/child END
    
  $(merchantTier).each(function(){
  let option = $('<option />');
  option.attr('value', this.cdmValue).text(this.cdmMeaning);
  els.merchantTiers.append(option);
  });


  }

  function setStates(countryVal) {
    els.state.html('');
    var option = $('<option />');
    option.attr('value', "-1").text('Select State/Province/Region');
    option.attr('selected','selected');
    option.attr('disabled','disabled');
    let checkZipCode = false;
      $(countries).each(function() {
        if(this.conCode.toString() === countryVal.toString()) {
            if(this.conPostalCodeRequired.toString() === "Y"){
              checkZipCode=true;
            }
        }
      });
    if(countryVal == "US" && checkZipCode) {
      show(els.stateSelectContainer);
      hide(els.stateTextContainer);
      //els.countyMandatoryLabel.show();
      //els.county.prop('required',false);

      els.state.prop('required',true);
      els.stateTextInput.prop('required',false);
      els.zipCode.addClass("zipcodeUS");
      els.zipCode.prop('required',true);

      els.state.append(option);
      els.stateLabel.text('State/Province/Region *');
      els.postalCodeLabel.text('Postal Code *');
      $(usaStates).each(function(){
        var option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        els.state.append(option);
      });
    } else if(countryVal == "CA" && checkZipCode) {
      show(els.stateSelectContainer);
      hide(els.stateTextContainer);
      //els.countyMandatoryLabel.hide();
    //  els.county.prop('required',false);

      els.state.prop('required',true);
      els.stateTextInput.prop('required',false);
      els.zipCode.removeClass("zipcodeUS");
      els.zipCode.prop('required',true);
      els.state.append(option);
      els.stateLabel.text('State/Province/Region *');
      els.postalCodeLabel.text('Postal Code *');
      $(caProvinces).each(function(){
        var option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        els.state.append(option);
      });
    } else {
      if(checkZipCode){
        els.stateLabel.text('State/Province/Region');
        els.postalCodeLabel.text('Postal Code *');
        els.state.prop('required',false);
        els.stateTextInput.prop('required',false);
        els.zipCode.removeClass("zipcodeUS");
        els.zipCode.prop('required',true);
        //els.zipCode.valid();
        //els.countyMandatoryLabel.hide();
        
        //els.county.prop('required',false);
        hide(els.stateSelectContainer);
        show(els.stateTextContainer);

      }else{
        els.stateLabel.text('State/Province/Region');
        els.postalCodeLabel.text('Postal Code');
        els.state.prop('required',false);
        els.stateTextInput.prop('required',false);
        els.zipCode.removeClass("zipcodeUS");
        els.zipCode.prop('required',false);
        els.zipCode.valid();
        //els.countyMandatoryLabel.hide();
        
        //els.county.prop('required',false);
        hide(els.stateSelectContainer);
        show(els.stateTextContainer);

      }
     
    }
  }

  function setSwithcery(checkbox, bool) {
    instantiateSwitchery(checkbox);
    setSwitchery(checkbox, bool);
  }


  function renderViewWithData() {
    showAllSections();
    const retailer = getRetailer();
    let insightFeedSwitchEl = els.insightFeedSwitch;
    let fuelSurchrgSwitchEl = els.fuelSurchrgSwitch;
    let directBillEl = els.directBillSwitch;

    if(_.isObject(retailer)) { // During edit, pre populate data
      if (!isNullOrUndefined(retailer.rtlInsightFeedFlag) && (insightFeedSwitchEl.length >0)){
        setSwithcery(els.insightFeedSwitch, retailer.rtlInsightFeedFlag);
      }
      if (!isNullOrUndefined(retailer.rtlFuelSurchrgDiscFlag) && (fuelSurchrgSwitchEl.length >0)){
        setSwithcery(els.fuelSurchrgSwitch, retailer.rtlFuelSurchrgDiscFlag);
      }  
      if (!isNullOrUndefined(retailer.directBillCustomerFlag) && (directBillEl.length >0)){
        setSwithcery(els.directBillSwitch, retailer.directBillCustomerFlag);
      }    
    } 
    const primaryAddress = getPrimaryAddress();
    if(_.isObject(primaryAddress)) { // During edit, pre populate data
      setData(primaryAddress);
    } else { // New retailer
      hide(els.mobilePhoneSection); // Not shown on initial load while creating new
    }
  }

  function setData(primaryAddress) {

    els.masterAccountToggleCheckbox.attr('checked', primaryAddress.rtlMasterFlag);
  

    els.managedByMasteraccountToggleCheckbox.attr('checked', primaryAddress.rtlVirtualFlag);
   
    
    els.masterAccountToggleCheckbox.checked=primaryAddress.rtlMasterFlag;
    els.managedByMasteraccountToggleCheckbox.checked=primaryAddress.rtlVirtualFlag;
    
    // E-111737 Enable ability to update individual merchant to parent/child START
    let retailerObj = getRetailer();
    if (_.isObject(retailerObj)) {
          if (retailerObj.rtlMasterFlag || retailerObj.rtlVirtualFlag) {              
              els.masterAccountToggleCheckbox.prop('readonly', true);
              els.managedByMasteraccountToggleCheckbox.prop('readonly', true);
              els.masteraccountDropdown.attr('disabled', 'disabled');
              els.masteraccountDropdown.prop('readonly', true);
          }
    }
    // E-111737 Enable ability to update individual merchant to parent/child END
    
      if(primaryAddress.rtlMasterFlag){
        els.managedByMasterAccountSection.addClass('q-display-none');
      } else {
        els.managedByMasterAccountSection.removeClass('q-display-none');
      }

      if(primaryAddress.rtlVirtualFlag){
        els.masterAccountSection.addClass('q-display-none');
      } else {
        els.masterAccountSection.removeClass('q-display-none');
      }

    
    

    els.companyName.val(primaryAddress.rtlName);
    //els.companyName.prop('readonly', true);
    if (!isBlank(primaryAddress.rtlTaxId)) {
      els.taxId.val(primaryAddress.rtlTaxId);
      els.taxId.prop('readonly', true);
    }
    /*if(primaryAddress.retailerFedExIds!=null){
    if (!isBlank(primaryAddress.retailerFedExIds.fontanaFedExId)) {
      els.fontanaFedExId.val(primaryAddress.retailerFedExIds.fontanaFedExId);
    }
    if (!isBlank(primaryAddress.retailerFedExIds.greenwoodFedExId)) {
      els.greenwoodFedexId.val(primaryAddress.retailerFedExIds.greenwoodFedExId);
    }
  }*/
    els.url.val(primaryAddress.rtlWebUrl);
    els.merchantTiers.val(primaryAddress.rtlTier).trigger("change");
    els.country.val(primaryAddress.rtlConCode).trigger("change");
    els.address1.val(primaryAddress.rtlAddress1);
    els.address2.val(primaryAddress.rtlAddress2);
    els.city.val(primaryAddress.rtlCity);

    if(primaryAddress.rtlConCode != "US" && primaryAddress.rtlConCode != "CA") { // Set state text input
      els.stateTextInput.val(primaryAddress.rtlState);
    } else {
      els.state.val(primaryAddress.rtlState).trigger("change");
    }

    els.zipCode.val(primaryAddress.rtlZip);
    els.county.val(primaryAddress.rtlCounty);

    els.prefix.val(primaryAddress.rtlContactNamePrefix).trigger("change");
    els.firstName.val(primaryAddress.rtlContactFirstName);
    els.lastName.val(primaryAddress.rtlContactLastName);
    els.email.val(primaryAddress.rtlEmail);

    els.fedexCanCall.prop("checked", primaryAddress.rtlOkToCall);

    els.officeCountryCode.val(primaryAddress.rtlOfficePhoneCountryCode).trigger("change");

    if(primaryAddress.rtlOfficePhoneCountryCode==='+1'){
      
      els.officePhone.attr("placeholder", "___-____");
      els.officePhone.addClass('ret-phone-number-jqv');
      els.officePhone.removeClass('phoneNonUS');
      els.officePhone.val(primaryAddress.rtlOfficePhone); 
      if(els.officeAreaCode){
        els.officeAreaCode.removeClass('phoneNonUS');     
        els.officeAreaCode.val(primaryAddress.rtlOfficePhoneAreaCode);
      }
      addmasks(); 
      
    }else{

      els.officePhone.addClass('phoneNonUS');
      els.officePhone.removeClass('ret-phone-number-jqv');
      els.officePhone.removeAttr('placeholder');
      els.officePhone.inputmask({mask: ""});    
    
      if(primaryAddress.rtlOfficePhoneAreaCode){
      	
        let val= primaryAddress.rtlOfficePhoneAreaCode;
        const v=val.replace(/[^0-9.]/g, "");
        primaryAddress.rtlOfficePhoneAreaCode=v;
        if(els.officeAreaCode){
          els.officeAreaCode.inputmask({mask: ""});
	        els.officeAreaCode.addClass('phoneNonUS');
          els.officeAreaCode.val(v);
	      }
      }  

      if(primaryAddress.rtlOfficePhone){
        let val= primaryAddress.rtlOfficePhone;
        const v=val.replace(/[^0-9.]/g, "");
        primaryAddress.rtlOfficePhone=v;
        els.officePhone.val(v);
      }     
      
      els.officeAreaCode.removeAttr('placeholder');
      els.officeAreaCode.inputmask({mask: ""});
      if(els.officeAreaCode){
        hide(els.officeAreaCode);
      }
    }
    
    els.officeExt.val(primaryAddress.rtlOfficePhoneExt);

    if(!isMobileInformationPresent(primaryAddress)) {
      els.mobileCountryCode.val(primaryAddress.rtlMobilePhoneCountryCode).trigger("change");

      
      if(primaryAddress.rtlMobilePhoneCountryCode==='+1'){
        els.mobilePhone.removeClass('phoneNonUS');
        if(els.mobileAreaCode){
          els.mobileAreaCode.removeClass('phoneNonUS');
        }  
        els.mobilePhone.addClass('ret-phone-number-jqv');
        els.mobilePhone.attr("placeholder", "___-____");
        
        addMasksMobilePhone();
        els.mobilePhone.val(primaryAddress.rtlMobilePhone);
        

        if(primaryAddress.rtlMobilePhoneAreaCode !=null){
          els.mobileAreaCode.val(primaryAddress.rtlMobilePhoneAreaCode); 
        }else{
          hide(els.mobileAreaCode);
        } 

      }else{

        els.mobilePhone.addClass('phoneNonUS');
        els.mobilePhone.removeClass('ret-phone-number-jqv');
        els.mobilePhone.removeAttr('placeholder');
        els.mobilePhone.inputmask({mask: ""});    
        
        if(primaryAddress.rtlMobilePhone){
          let val= primaryAddress.rtlMobilePhone;
          const v=val.replace(/[^0-9.]/g, "");
          primaryAddress.rtlMobilePhone=v;
          els.mobilePhone.val(v);
        }
  
        if(els.mobileAreaCode){
          els.mobileAreaCode.inputmask({mask: ""});
          els.mobileAreaCode.addClass('phoneNonUS');
          els.mobileAreaCode.removeAttr('placeholder');          
        }

	      if(primaryAddress.rtlMobilePhoneAreaCode){
          let val= primaryAddress.rtlMobilePhoneAreaCode;
          const v=val.replace(/[^0-9.]/g, "");
          primaryAddress.rtlMobilePhoneAreaCode=v;
          els.mobileAreaCode.val(v);
        }	
        if(els.mobileAreaCode){
        hide(els.mobileAreaCode);
        }
        
      }
      
      hide(els.addMobileBtn);
    } else {
      hide(els.mobilePhoneSection);
      show(els.addMobileBtn);
    }

    if(primaryAddress.childRetailers && primaryAddress.childRetailers.length > 0){
      $('#affMerchantSwitchery').attr('checked', true);
      $.each(primaryAddress.childRetailers, function(ind, child){
        let affMerchantNameValue = child.chrName;         
        let addedAffiliatedMerchantHtml = ` <div class="col-xs-12 aff-merchant-text q-marg-top-md">
            <input class="q-input q-stretch affMerchantNameValue" disabled
              type="text" id="${affMerchantNameValue}" value="${affMerchantNameValue}"/>
          </div>`;
        els.addAffMerchant.append(addedAffiliatedMerchantHtml);       
      });
    }

  }

  function handleAddMobileBtn() {
    show(els.mobilePhoneSection);
    hide(els.addMobileBtn);
  }

  function handleRemoveMobileBtn() {
    hide(els.mobilePhoneSection);
    show(els.addMobileBtn);
    els.mobileCountryCode.val('');
    els.mobileAreaCode.val('');
    els.mobilePhone.val('');
    const primaryAddress = getPrimaryAddress();

    if(primaryAddress){
      primaryAddress.rtlMobilePhoneCountryCode='';
      primaryAddress.rtlMobilePhone='';
      primaryAddress.rtlMobilePhoneAreaCode='';  
    }
  }

  function isMobileInformationPresent(primaryAddress) {
    return isBlank(primaryAddress.rtlMobilePhoneCountryCode)
      && isBlank(primaryAddress.rtlMobilePhone)
      && isBlank(primaryAddress.rtlMobilePhoneAreaCode);
  }

  function showAllSections() {
      show(els.addressSection);
      show(els.contactSection);
      show(els.phoneSection);
  }

  function countryChange() {
    let countryVal = els.country.find('option:selected').val();
    let isValidCountry = false;
    $(countries).each(function() {
      if(this.conCode.toString() === countryVal.toString()) {
        countryId = this.conPhoneCode.toString();
        return false;
      } 
    });
    $(validationReqdCountries).each(function() {
      if(this.cdmValue.toString() === countryVal.toString()) {
        isValidCountry = true;
        return false;
      } 
    });
    if(isValidCountry){
      $(".country-not-supported-primary").hide();        
    }else{
      $(".country-not-supported-primary").show();
    }
    setStates(countryVal);
    if(countryVal === "US"){
      $(".ret-office-country-code option").filter(function() {
        let text= $(this).text().toString();
        return text === "United States of America +1";
    }).prop("selected", true).trigger("change");
    }else if(countryVal === "CA"){
      $(".ret-office-country-code option").filter(function() {
        let text= $(this).text().toString();
        return text === "Canada +1";
    }).prop("selected", true).trigger("change");
    }else if(countryVal === "UM"){
      $(".ret-office-country-code option").filter(function() {
        let text= $(this).text().toString();
        return text === "United States Minor Outlying Islands +1";
    }).prop("selected", true).trigger("change");
    }else{
      $(".ret-office-country-code option").filter(function() {
        let text= $(this).val().toString();
        return text === countryId.toString();
    }).prop("selected", true).trigger("change");
    }
    if(countryVal === "US" || countryVal === "CA" ){
      show(els.officeAreaCode);
      els.officePhone.attr("placeholder", "___-____");
      els.officePhone.addClass('ret-phone-number-jqv');
      els.officePhone.removeClass('phoneNonUS');
      addmasks();
    }else {
      els.officeAreaCode.val('');
      if(els.officeAreaCode){
        hide(els.officeAreaCode);
      }
      els.officePhone.val('');
      els.officePhone.addClass('phoneNonUS');
      els.officePhone.removeClass('ret-phone-number-jqv');
      els.officePhone.removeAttr('placeholder'); 
      els.officePhone.inputmask({
        mask: ""
      }); 
    }
  }

  function addmasks(){
    $('.ret-office-area-code').inputmask({
      mask: "(999)"
    });

    $('.ret-office-phone').inputmask({
      mask: "999-9999"
    });
  }

  function addMasksMobilePhone(){
    $('.ret-mobile-area-code').inputmask({
      mask: "(999)"
    });

    $('.ret-mobile-phone').inputmask({
      mask: "999-9999"
    });
  }

  function mobileCountryCodeChange(){
    let mobilecode  = els.mobileCountryCode.find('option:selected').val().toString();
    els.mobilePhone.val('');
    if(els.mobileAreaCode){
      els.mobileAreaCode.val('');
    }
    if(els.mobileAreaCode){
      els.mobileAreaCode.val('');
    }
    if( mobilecode === '+1'){
      show(els.mobileAreaCode);
      els.mobilePhone.attr("placeholder", "___-____");
      els.mobilePhone.addClass('ret-phone-number-jqv');
      els.mobilePhone.removeClass('phoneNonUS');
      if(els.mobileAreaCode){
        els.mobileAreaCode.removeClass('phoneNonUS');        
      }
      addMasksMobilePhone();
  }else{     
      els.mobileAreaCode.removeClass('phoneNonUS');
      els.mobileAreaCode.val(''); 
      hide(els.mobileAreaCode);
      els.mobilePhone.addClass('phoneNonUS');
      els.mobilePhone.removeClass('ret-phone-number-jqv');
      els.mobilePhone.removeAttr('placeholder');
      els.mobilePhone.inputmask({mask: ""});

    }
  }

  function officeCountryCodeChange(){
    let phoneCode = els.officeCountryCode.find('option:selected').val().toString();
    els.officePhone.val('');
    if(els.officeAreaCode){
      els.officeAreaCode.val('');
    }
    if( phoneCode === '+1'){
      show(els.officeAreaCode);      
      els.officePhone.attr("placeholder", "___-____");
      els.officePhone.addClass('ret-phone-number-jqv');
      els.officePhone.removeClass('phoneNonUS');
      if( els.officeAreaCode){
        els.officeAreaCode.removeClass('phoneNonUS');      
       }
      addmasks();
    }else{     
      hide(els.officeAreaCode);
      els.officePhone.addClass('phoneNonUS');
      els.officePhone.removeClass('ret-phone-number-jqv');      
      els.officePhone.removeAttr('placeholder'); 
      els.officePhone.inputmask({mask: ""});
    }
  }

  function getRetailer() {
    if(!isBlank(retailerJsonString)) {
      return retailerJsonString;
    } else {
      return null;
    }
  }

  function getPrimaryAddress() {
    return getRetailer();
  }

  function existingRetailerHasPrimaryAddress() {
    return _.isObject(getRetailer());
  }

  function isEdit() {
    return _.isObject(getRetailer());
  }

  function validateDirectBillField(){   

    if($(this).prop("checked") == true){
      if($('.primary-information-tab .fuel-Surchrg-switch').is(":checked")){
        const retailer = getRetailer();
        let directBillEl = els.directBillSwitch;
        if (!isNullOrUndefined(retailer.directBillCustomerFlag) && (directBillEl.length >0)){
          setSwithcery(els.directBillSwitch, false);
        }       
      } 
    }
  }

  function validateFuelSurchargeField(){
    if($(this).prop("checked") == true){
      if($('.primary-information-tab .direct-bill-switch').is(":checked")){
        const retailer = getRetailer();
        let fuelSurchrgSwitchEl = els.fuelSurchrgSwitch;
        if (!isNullOrUndefined(retailer.rtlFuelSurchrgDiscFlag) && (fuelSurchrgSwitchEl.length >0)){
          setSwithcery(els.fuelSurchrgSwitch, false);
        }
      }      
    }   
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/maintainRetailer/PrimaryTab.js